
<router-outlet *ngIf="!isIframe"></router-outlet>
<!-- <div class="loading-icon" *ngIf="loading">
  Cargando...
</div> -->
